import { Injectable } from '@angular/core';
import { FoldersViewController } from '@commoncore/controller/FoldersViewController';
import { GlobalService } from '@commoncore/services/global.service';
import { TeamFolderService } from '@commoncore/services/team-folder.service';
import { AppEvents, EventsList } from '@commoncore/utils/app-events';
import { SORT_ORDER } from '../constants/Constants';

@Injectable({
  providedIn: 'root'
})
export class UploadNotificationService {
  uploadDetails: { object: any; openlocation: any; forceChangeSortAndLayout: any; };
  router: any;
  universalService: any;
  listService: any;
  contextMenuRef: any;
  contextMenuMobile: any;
  customMetadata: any;
  static singleInstance:any = null;

  constructor(public globalService:GlobalService) { 
    this.universalService = globalService.getUniversalServiceRef();
    this.listService = globalService.getListServiceRef();
    this.router = globalService.getRouterRef();
    this.contextMenuRef = this.globalService.getContextMenuServiceRef();
    this.contextMenuMobile = this.globalService.getContextMenuMobileServiceRef();
    this.customMetadata = this.globalService.getCustomMetadataServiceRef()
  }

  public static getInstance(globalService):UploadNotificationService{
    if(this.singleInstance == null){
      this.singleInstance = new UploadNotificationService(globalService);
      return this.singleInstance;
    }else{
      return this.singleInstance;
    }
  }


  setUploadedData(file,openlocation,forceChangeSortAndLayout){
    this.uploadDetails = {
      "object":file,
      "openlocation":openlocation,
      "forceChangeSortAndLayout":forceChangeSortAndLayout
    }
  }

  getUploadedData(){
    return this.uploadDetails
  }

  resetUploadedData(){
    this.uploadDetails = undefined
  }

  selectUploadedFileIfPresentInView(file){
    if(!this.router.url.includes(file["currentFolderKey"])) return;

    jQuery(".tab-content").find(".grid_info").removeClass("grid_info");
    jQuery(".tab-content").find(".list_info").removeClass("list_info");

    
    let arrayToSearch = this.universalService.MarkNewObjArray;
    if(file.isFolder){
      arrayToSearch = this.universalService.foldersArray;
    }

    let findFile = arrayToSearch.find(obj=> obj["objectKey"] == file["objectKey"])
    if(!findFile){
      return;
    }
    findFile = this.populateRequiredMetadataIntoObjectPostUpload(findFile);
    this.universalService.operationInProgress = true;
    this.universalService.selectedNodes = [findFile];
    this.universalService.selectedFile = findFile
    delete this.universalService.selectedFile["previewFromUpload"];

    if(!this.universalService.listView && !this.universalService.isMobileDevice){
      let target = this.universalService.selectedNodes[0].objectKey;
      this.contextMenuRef.decideContextMenuItemsForDesktop();   
      this.universalService.showTopMenuOptions();  
      let ele = document.querySelectorAll('.gridItem')
      this.universalService.selectedNodes.forEach(obj => {
        ele.forEach(item =>{
          if(obj.objectKey == item.id){
            this.universalService.showTopMenu = true; 
            item.classList.add('grid_info');
          }
        })
      });
      AppEvents.virtualDOMObservable.next({"saveSelectedObjects":true})
      this.universalService.selectedFile = this.universalService.selectedNodes[0]

      let element = document.querySelectorAll("[id='"+target+"']")
      this.checkIfWeNeedToExpandFolderSection();
      
      if(element != null && element.length != 0) {
        setTimeout(() => {
          element[element.length-1].scrollIntoView();
        }, 10);
       
      } else {
        this.universalService.selectedNodes = [];
        this.universalService.hideTopMenuOptions();
      }
    }else if(this.universalService.listView && !this.universalService.isMobileDevice){
      // setTimeout(()=>{
        var indexes = [];
        // this.universalService.MarkNewObjArray.map(obj=>{
          var find = this.universalService.allNodesDataFromListView.find(node=>node["data"]["objectId"] == file["objectKey"]);
          if(find){
            var idx = this.universalService.allNodesDataFromListView.indexOf(find);
            if(idx != -1){
              indexes.push(idx)
            }
          }
        // })
        indexes.map(idx=>{
          let rowNode = this.listService.listOptions.api.getDisplayedRowAtIndex(idx);
          rowNode.setSelected(true);
          this.universalService.showTopMenu = true; 
        })
        this.checkIfWeNeedToExpandFolderSection();
        this.universalService.selectedRowAfterUpload =[];
        setTimeout(()=>{
          // this.universalService.isViewFileClicked = true;
          this.listService.listOptions.api.ensureIndexVisible(this.universalService.slectedRowId);
          var selectedRows = document.querySelectorAll('.ag-center-cols-clipper .ag-row-selected')
          selectedRows[0]?.scrollIntoView(); // scroll to selected
        },100)  
      // },50)
    }else if(this.universalService.isMobileDevice){
      this.universalService.mobileSelectionModeOn = true;
      let target = this.universalService.selectedNodes[0].objectKey;
      this.contextMenuRef.decideContextMenuItems();   
      let ele;
      if(this.universalService.listView){
        ele = document.querySelectorAll('.listItem')
      }else{
        ele = document.querySelectorAll('.gridItem')
      }
      this.universalService.selectedNodes.forEach(obj => {
        ele.forEach(item =>{
          if(obj.objectKey == item.id){
            if(this.universalService.listView){
              item.classList.add('list_info');
            }else{
              item.classList.add('grid_info');
            }  
          }
        })
      });
      let element = document.querySelectorAll("[id='"+target+"']")
      if(element != null && element.length != 0) {
        setTimeout(() => {
          element[element.length-1]?.scrollIntoView();
        }, 10);
      } else {
        this.universalService.selectedNodes = [];
        this.universalService.hideTopMenuOptions();
      }
      this.checkIfWeNeedToExpandFolderSection();
    }

    setTimeout(() => {
      this.universalService.operationInProgress = false;
    }, 1000);
  }

  checkIfWeNeedToExpandFolderSection(){
    let controller = FoldersViewController.getInstance(this.globalService)
    let implRef = controller.folderViewImplementation;
    var found = this.universalService.MarkNewObjArray.find(obj=>(obj["FullObject"]?obj["FullObject"]["objectType"]:obj["objectType"]) == "FR")
    if(found){
      var objIndex = -1;
      this.universalService.foldersArray.filter(function(obj,index){
        if(obj["objectKey"] == found["objectKey"]){
          objIndex = index
          return false;
        }
      });
      if(objIndex >= 11){
        implRef.folderShownCount = this.universalService.foldersArray.length;
      }
    }
  }


  populateRequiredMetadataIntoObjectPostUpload(file){
    let resp = this.customMetadata.segregateData([file],'allfiles');
    if(resp[0]["uploadInitiatedModule"] == "sharedFiles"){
      resp = this.customMetadata.setAccessRights(resp)
    }else if(resp[0]["uploadInitiatedModule"] == 'teamfolders'){
      let teamfolderService = new TeamFolderService();
      resp = teamfolderService.setCustomMetadataForTeamFolders(resp);
    }else if(resp[0]["uploadInitiatedModule"] == "Album Details"){
      resp = this.customMetadata.setOwnerDetails(resp)
    }

    return resp[0];
  }


  changeSortingToGridViewAndSelectFile(){
    AppEvents.emit(EventsList.CHANGE_VIEW,{forceResetToGridView:true,sortOrder:SORT_ORDER["UPLOAD_SORTING"]})
  }
  
  
  selectFromPostSort(){
    if(this.uploadDetails){
      this.selectUploadedFileIfPresentInView(this.uploadDetails["object"]);
      this.resetUploadedData();
    }
  }
}
